module.exports = __webpack_public_path__ + "static/media/KingsPunjab.75ce27d4.jpg";